import Vue from 'vue';
import { Component } from 'vue-property-decorator';
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table'
import { Area } from './area.model'
import AreaService from './area.service';
import Visible from "../../directives/visible";

@Component({
    name: 'area_component',
    components: {
        VueGoodTable
    },
    directives: {
        Visible,
    },
})
export default class AreaComponent extends Vue {
    service: AreaService = new AreaService();
    areasPage: Area[] = [];
    selectedIndex: Area[] = [];
    newarea: Area = new Area();

    columnsConfig = [
        {
            label: 'Name',
            field: 'text',
        },
    ];
    selectConfig = {
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: this.getSelectionTextStr(),
        clearSelectionText: this.getClearStr(),
        disableSelectInfo: false, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
    };

    constructor() {
        super();
        this.selectedIndex = [];
    }

    mounted() {
        this.fetchareas();
    }

    selectionChanged(params) {
        console.log("selection cell=" + JSON.stringify(params));
        this.selectedIndex = params.selectedRows;
        // params.selectedRows - all rows that are selected (this page)
    }

    getClearStr() {
        return this.$i18n.t('comClear').toString();
    }

    getSelectionTextStr() {
        return this.$i18n.t('comSelectionCnt').toString();
    }

    fetchareas() {
        this.service.fetchareas()
            .then(data => {
                this.areasPage = data as Area[];
                console.log(this.areasPage);
            });
    }

    postarea() {
        let parentId: number | undefined;
        parentId = this.selectedIndex.length > 0 ? this.selectedIndex[0].dbId : 0;
        this.service.postarea(this.newarea, parentId);
        this.fetchAndClear();
    }

    deleteSelected() {
        if (this.selectedIndex.length > 0) {
            this.service.deleteareas(this.selectedIndex);
            this.fetchAndClear();
        }
    }

    updateSelected() {
        if (this.selectedIndex.length > 0) {
            this.service.updatearea(this.selectedIndex[0]);
            this.fetchAndClear();
        }
    }

    clearSelection() {
        this.selectedIndex = [];
    }

    // Fetches the data after 1 second and also clears the inputs etc.s
    fetchAndClear() {
        // Create a new Promise and resolve after 1 seconds
        var myTimerPromise = new Promise((resolve, reject) => {
            setTimeout(resolve, 1000);  // "resolve" is already a function, no need for another anonymous function here
        });

        // Fetch data now, within Promise.all()
        Promise.all([myTimerPromise]).then(() => {
            this.fetchareas();
            this.clearSelection();
            this.newarea = new Area();
        });
    }
}